const apiUrl = process.env.REACT_APP_API_URL;
export const GetPropostes = async ( page : string, filtre : string, idUsu: number = 0): Promise<any[]> => {
    try {
        const url = `${apiUrl}:8072/propostes?filtres=${filtre}&id_usu=${idUsu}`;
        console.log('[GetPropostes] GET', url);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        console.log('[GetPropostes] status:', response.status);
        if (!response.ok) {
            const text = await response.text();
            console.error('[GetPropostes] error body:', text);
            return [];
        }
        const jsonData = await response.json();
        console.log('[GetPropostes] jsonData:', jsonData);
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('[GetPropostes] fetch error:', error);
        return [];
    }
};
